// extracted by mini-css-extract-plugin
export default {"wrap":"Pr-z","melodyCategory":"Qr-z","fullWidth":"Rr-z","items":"Sr-z","featureCss":"Tr-z","disabled":"Ur-z","imgCss":"Vr-z"};